import React, { PureComponent } from "react";

export default class DK extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.34"
      >
        <g transform="translate(0 -85.33)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.333)"
            fill="#d80027"
          />
          <path
            d="M192,85.33H128V224H0v64H128V426.662h64V288H512V224H192Z"
            fill="#f0f0f0"
          />
        </g>
      </svg>
    );
  }
}
